import { appendQueryParams } from '@packages/shared/core/common/utils/url/appendQueryParams';
import { useServices } from '@packages/shared/core/common/hooks/useServices';
import { normalizeError } from '@packages/shared/core/common/utils/errors';
import { checkIsClientSide } from '@packages/shared/core/common/utils/checkIsClientSide';

export const useRedirectWithQueryParams = () => {
  const { logger } = useServices();

  const redirectWithQueryParams = async ({ url, params }: { url: string; params: Record<string, string> }) => {
    if (!checkIsClientSide()) return;

    try {
      const URLToRedirect = new URL(url);

      const URLToRedirectWithParams = appendQueryParams(URLToRedirect, params);
      window.location.assign(URLToRedirectWithParams.href);
    } catch (e) {
      const error = normalizeError(e);
      logger.error(error);
    }
  };

  return { redirectWithQueryParams };
};
